<template>
  <div class="store-header-box show-flex-box-r show-flex-center">
    <div
      class="show-flex-box-c"
      :class="{
        'hide-second-nav':
          routerInfo == 'course_redemption' ||
          routerInfo == 'ins_management' ||
          curPosition == 'ins_personal_center',
      }"
    >
      <dl class="workstation-box show-flex-box-r">
        <dt class="show-flex-box-r">
          <strong @click="tabToHome">
            <img
              src="../../assets/common/logo_black_icon.png"
              alt="德阳经开科创"
              draggable="false"
            />
          </strong>
        </dt>
        <dd class="store-page-list show-flex-box-r">
          <div class="page-list show-flex-box-r">
            <ul class="show-flex-box-r">
              <li
                class="classifacation-font-white show-flex-box-r"
                :class="{
                  'classifacation-font-white-active': curPosition == item.mark,
                }"
                v-for="(item, index) in headerClass"
                :key="index"
                @click="tabToJumpSubcategory(item.title)"
              >
                <strong>{{ item.name }}</strong>
              </li>
            </ul>
          </div>
          <div class="user-info-list show-flex-box-r">
            <span
              :class="{
                'course-redemption-selected': routerInfo == 'course_redemption',
              }"
              class="course-redemption-white show-flex-box-r show-flex-center"
              v-if="routerInfo != 'ins_management'"
              @click="tabToRedemptionCourse"
            >
              <strong>课程兑换</strong>
            </span>
            <div
              class="user-info show-flex-box-r"
              v-if="logined"
              @click="tabToPersonalCenter"
            >
              <span v-if="userInfo && userInfo.avatar">
                <img
                  :src="userInfo.avatar"
                  alt="德阳经开科创"
                  v-if="userInfo.avatar"
                  draggable="false"
                />
              </span>
              <h1 class="hide-line1" v-if="userInfo.nickname">
                {{ userInfo.nickname }}
              </h1>
            </div>
          </div>
        </dd>
      </dl>
      <div
        class="store-box show-flex-box-r"
        v-if="
          routerInfo != 'course_redemption' &&
          routerInfo != 'ins_management' &&
          curPosition != 'ins_personal_center'
        "
      >
        <dl class="show-flex-box-r">
          <dt class="show-flex-box-r">
            <ul class="show-flex-box-r">
              <li
                class="show-flex-box-r"
                :class="{ 'cur-store-active': routerInfo == Ditem.title }"
                v-for="(Ditem, Dindex) in childrenHeader"
                :key="Dindex"
                @click="tabToJumpMoreStore(Ditem.title)"
              >
                <span class="show-flex-box-r show-flex-center b-bottom">
                  <strong>{{ Ditem.name }}</strong>
                </span>
              </li>
            </ul>
          </dt>
          <dd
            class="shopping-cart show-flex-box-r"
            :class="{ 'cur-store-active': routerInfo == 'shopping_cart_frame' }"
            @click="jumpShoppingCart"
          >
            <span></span>
            <h1>购物车</h1>
            <strong
              class="show-flex-box-r"
              v-if="$store.state.shoppingCartNum < 100"
            >
              <span>{{ $store.state.shoppingCartNum }}</span>
            </strong>
            <strong class="show-flex-box-r more-count" v-else>
              <span>99+</span>
            </strong>
          </dd>
          <dd
            class="my-order show-flex-box-r"
            :class="{ 'cur-store-active': routerInfo == 'my_order' }"
            @click="tabToJumpMoreStore('my_order')"
          >
            <span></span>
            <strong>我的订单</strong>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import regex from "@/filter/regex";

export default {
  name: "store_header_cpn",
  data() {
    return {
      headerClass: [
        { name: "课程", title: "ins_course", mark: "ins" },
        // {'name': '编程创作', 'title': 'scratch', 'mark': ''},
        // {'name': '机构论坛', 'title': 'teacher_forum', 'mark': 'teacherForum'},
        { name: "在线商城", title: "course_store", mark: "store" },
      ],
      childrenHeader: [
        { name: "德阳经开科创", title: "marsbox_store" },
        { name: "课程", title: "course_store" },
        // {'name': '在线直播', 'title': 'live_online'}
      ],
      agentData: {
        name: "机构管理",
        title: "institutional_management",
        mark: "management",
      },
      routerInfo: "marsbox_store",
      defautStore: "marsbox_store",
      finderStyle: "none",
      logined: false,
      userInfo: {},
      curPosition: "",
      scratchUrl: "",
    };
  },
  computed: {
    listenToken: function () {
      return this.$store.state.token;
    },
    listenUserInfo: function () {
      return this.$store.state.user;
    },
  },
  created() {
    this.isGetUserInfo();
  },
  mounted() {
    this.checkAgent();
    this.reqRouterPath();
    this.reqShoppingCartTotalNum();
    // this.getOrderCount();
  },
  methods: {
    tabToPersonalCenter: function () {
      let toWhere = "/personal/set/ins_personal_center/project";
      this.$router.push({ path: toWhere });
    },
    tabToRedemptionCourse: function () {
      this.curPosition = "redemption";
      let toWhere = "/course_redemption/redemption";
      this.$router.push({ path: toWhere });
    },
    reqShoppingCartTotalNum: function () {
      this.$client
        .reqShoppingCartTotalNum()
        .then((res) => {
          this.$store.commit("GET_SHOPPINGCART_NUM", res.data.count);
        })
        .catch((err) => {});
    },
    jumpShoppingCart: function () {
      let toWhere = "/mars_box_store/shopping_cart_frame/store";
      this.$router.push({
        path: toWhere,
        query: { type: "cart", production: "sku" },
      });
    },
    tabToHome: function () {
      let toWhere = "/";
      this.$router.push({ path: toWhere });
    },
    tabToJumpMoreStore: function (curStore) {
      this.defautStore = curStore;
      let toWhere = "/mars_box_store/" + curStore + "/store";
      this.$router.push({ path: toWhere });
    },
    isGetUserInfo: function () {
      let userToken = this.$store.state.token;
      let tokenStatus = regex.isTrueResult(userToken);

      if (tokenStatus) {
        this.getUserInfo();
        this.checkUserStatus();
      }
    },
    checkUserStatus: function () {
      let userStore = this.$store.state.user;
      let userStatus = regex.isTrueResult(userStore);

      if (userStatus) {
        this.logined = regex.isTrueResult(this.$store.state.loginStatus);
        this.userInfo = this.formatUserInfoByType(userStore);
      } else {
        this.userInfo = {};
        this.logined = regex.isTrueResult(this.$store.state.loginStatus);
      }
    },
    //用户信息数据类型转换
    formatUserInfoByType: function (userStore) {
      let dataType = typeof userStore;
      let userObj = userStore;

      // if (dataType == 'string') {
      //   userObj = $.parseJSON(userStore);
      // }

      return userObj;
    },
    getUserInfo: function () {
      let vSelf = this;

      this.$client
        .getUserInfo()
        .then((res) => {
          if (res.code === "200" || res === 200) {
            vSelf.userInfo = res.data;
            // console.log(JSON.stringify(res.data));
            let curUserInfo = vSelf.saveUserInfo(res.data);
            vSelf.$store.commit("GET_USER", curUserInfo);
          }
        })
        .catch((err) => {});
    },
    // 保存用户信息
    saveUserInfo: function (userObj) {
      let userInfo;

      userInfo = {
        nickname: userObj.nickname,
        avatar: userObj.avatar,
        is_agents: regex.isTrueResult(userObj.is_agents),
        is_teacher: regex.isTrueResult(userObj.is_teacher),
        can_view_organ_post: regex.isTrueResult(userObj.can_view_organ_post),
        agents_teacher_max_num: userObj.agents_teacher_max_num,
        agents_teacher_num: userObj.agents_teacher_num,
        invitation_code: userObj.agents_invite_code,
        last_invoice_config: userObj.last_invoice_config,
      };
      return userInfo;
    },
    tabToJumpSubcategory: function (pathName) {
      if (pathName == "course_store") {
        let toWhere = "/mars_box_store/marsbox_store/store";
        this.$router.push({ path: toWhere });
      } else if (pathName == "ins_course") {
        let toWhere =
          "/mars_box_ins/ins_entrance/ins_course_home/ins/ins_course_home";
        this.$router.push({ path: toWhere });
      } else if (pathName == "teacher_forum") {
        if (this.userInfo.can_view_organ_post) {
          let toWhere =
            "/mars_box_ins/ins_entrance/ins_teacher_home/teacherForum/teacherForum";
          this.$router.push({ path: toWhere });
        } else {
          this.$elementMsg.error({
            message: "无论坛权限，请联系德阳经开科创创新创客中心管理员，开通权限",
            showClose: true,
            customClass: "pop-class-error",
            duration: 3000,
          });
        }
      } else if (pathName == "institutional_management") {
        let toWhere = "/ins_management/management/account_information";
        this.$router.push({ path: toWhere });
      }
      // else if (pathName == 'scratch') {
      //   window.location.href = this.scratchUrl;
      // }
    },
    reqRouterPath: function () {
      this.routerInfo = this.$route.name;
      this.curPosition = this.$route.params.type;
    },
    checkAgent: function () {
      // if (this.userInfo.is_agents && this.headerClass.length < 4) {
      //   this.headerClass.push(this.agentData);
      // }
      let arr = this.headerClass.filter(
        (item) => item.title == "institutional_management"
      );
      if (this.userInfo.is_agents && arr.length == 0 && this.headerClass.length < 3) {
        this.headerClass.push(this.agentData);
      }
    },
  },
  watch: {
    $route: function (from) {
      this.reqRouterPath();
      this.curPosition = this.$route.params.type;
    },
    listenToken: function () {
      let tokenStatus = regex.isTrueResult(this.listenToken);

      if (tokenStatus) {
        this.getUserInfo();
      } else {
        this.logined = false;
      }
    },
    listenUserInfo: function () {
      this.checkUserStatus();
      this.checkAgent();
    },
  },
};
</script>

<style lang="less" scoped>
.store-header-box {
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  // min-width: 1400px;
  z-index: 999;
  background: #fff;
  & > div {
    width: 100%;
    height: 120px;
    // align-items: center;
    & > .workstation-box {
      // min-width: 1200px;
      padding-left: 10%;
      padding-right: 18%;
      flex-grow: 1;
      height: 60px;
      // justify-content: space-between;
      align-items: center;
      // padding-right: 160px;
      & > dt {
        // width: 100%;
        padding-right: 54px;
        // align-items: center;
        & > strong {
          display: block;
          width: 110px;
          // padding-right: 50px;
          cursor: pointer;
          & > img {
            width: 100%;
          }
        }
      }
      & > .store-page-list {
        width: 100%;
        flex-grow: 1;
        // justify-content: space-between;
        align-items: center;
        & > .page-list {
          width: 100%;
          // flex-grow: 1;
          & > ul {
            width: 100%;
            align-items: center;
            & > .classifacation-font-white {
              white-space: nowrap;
              padding-right: 54px;
              & > strong {
                display: block;
                font-size: 18px;
                color: #191d21;
                font-weight: 500;
                cursor: pointer;
                transition: 0.3s all;
              }
              & > strong:hover {
                color: #ff7800;
              }
            }
            & > .classifacation-font-white-active {
              padding-right: 54px;
              & > strong {
                color: #ff7800;
              }
            }
          }
        }
        & > .user-info-list {
          flex-shrink: 0;
          & > .course-redemption-white {
            width: 118px;
            height: 38px;
            margin-right: 20px;
            border: 1px solid #ff7800;
            border-radius: 20px;
            cursor: pointer;
            transition: 0.3s all;
            & > strong {
              display: block;
              font-size: 18px;
              color: #ff7800;
              font-weight: 500;
              line-height: normal;
              transition: 0.3s all;
            }
          }
          & > .course-redemption-white:hover {
            width: 118px;
            height: 38px;
            background: #ff7800;
            & > strong {
              display: block;
              font-size: 18px;
              color: #fff;
              font-weight: 500;
              line-height: normal;
            }
          }
          & > .course-redemption-selected {
            width: 118px;
            height: 38px;
            background: #ff7800;
            & > strong {
              display: block;
              font-size: 18px;
              color: #fff;
              font-weight: 500;
              line-height: normal;
            }
          }
          //banner 图外
          & > .user-info {
            width: 130px;
            align-items: center;
            cursor: pointer;
            & > span {
              overflow: hidden;
              display: flex;
              width: 40px;
              height: 40px;
              border-radius: 100%;
              overflow: hidden;
              margin-right: 13px;
              & > img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                flex-grow: 1;
              }
            }
            & > h1 {
              display: block;
              font-size: 18px;
              color: #191d21;
              font-weight: 500;
              transition: 0.3s all;
            }
          }
          & > .apply-trial-white {
            width: 118px;
            height: 38px;
            margin-right: 20px;
            border: 1px solid #ff7800;
            border-radius: 20px;
            cursor: pointer;
            transition: 0.3s all;
            & > span {
              display: block;
              font-size: 18px;
              color: #ff7800;
              font-weight: 500;
              line-height: normal;
              transition: 0.3s all;
            }
          }
          & > .apply-trial-white:hover {
            width: 118px;
            height: 38px;
            background: #ff7800;
            & > span {
              display: block;
              font-size: 18px;
              color: #fff;
              font-weight: 500;
              line-height: normal;
            }
          }
        }
      }
    }
    & > .store-box {
      padding-left: 10%;
      padding-right: 18%;
      flex-grow: 1;
      height: 60px;
      // justify-content: center;
      align-items: center;
      background: linear-gradient(
        89deg,
        rgba(255, 113, 115, 0.1) 0%,
        rgba(236, 199, 35, 0.1) 100%
      );
      & > dl {
        // min-width: 1200px;
        padding-left: 116px;
        flex-grow: 1;
        height: 60px;
        & > dt {
          width: 100%;
          // flex-grow: 1;
          & > ul {
            align-items: center;
            justify-content: space-between;
            & > li {
              width: 120px;
              height: 58px;
              cursor: pointer;
              transition: all 0.5s;
              border-bottom: 2px solid rgba(0, 0, 0, 0);
              & > span {
                width: 100%;
                & > strong {
                  display: block;
                  font-size: 18px;
                  line-height: auto;
                  color: #191d21;
                  font-weight: 500;
                }
              }
            }
            & > li:hover {
              height: 58px;
              border-bottom: 2px solid #ff7800;
              background: #fff;
            }
            & > .cur-store-active {
              height: 58px;
              border-bottom: 2px solid #ff7800;
              background: #fff;
            }
          }
        }
        & > .shopping-cart {
          width: 153px;
          height: 58px;
          justify-content: center;
          align-items: center;
          transition: all 0.5s;
          border-bottom: 2px solid rgba(0, 0, 0, 0);
          cursor: pointer;
          & > span {
            width: 23px;
            height: 23px;
            background: url("../../assets/mars_store/shopping_cart_header_icon.png")
              no-repeat center center;
            background-size: 23px 23px;
            margin-right: 10px;
          }
          & > h1 {
            display: block;
            font-size: 18px;
            word-wrap: none;
            line-height: normal;
            color: #808080;
            font-weight: 500;
            white-space: nowrap;
          }
          & > strong {
            width: 18px;
            height: 18px;
            background: #ff7800;
            border-radius: 50%;
            justify-content: center;
            align-items: center;
            margin-left: 4px;
            & > span {
              display: block;
              font-size: 14px;
              font-weight: 500;
              color: #fff;
              line-height: normal;
            }
          }
          & > .more-count {
            width: 30px;
            border-radius: 14px;
          }
        }
        & > .my-order {
          width: 153px;
          height: 58px;
          justify-content: center;
          align-items: center;
          transition: all 0.5s;
          border-bottom: 2px solid rgba(0, 0, 0, 0);
          cursor: pointer;
          & > span {
            width: 22px;
            height: 22px;
            background: url("../../assets/mars_store/my_order_entrance_icon.png")
              no-repeat center center;
            background-size: 22px 22px;
            margin-right: 10px;
          }
          & > strong {
            display: block;
            font-size: 18px;
            word-wrap: none;
            line-height: auto;
            color: #808080;
            font-weight: 500;
            white-space: nowrap;
          }
        }
        & > .cur-store-active {
          height: 58px;
          border-bottom: 2px solid #ff7800;
          background: #fff;
        }
      }
    }
  }
  & > .hide-second-nav {
    height: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/store_header_cpn.vue